import React, { 
  //useState 
} from 'react';
import { Link } from "gatsby"

import {
  List,
  Image,
} from 'semantic-ui-react';

export default function ContentList(props) {
  //console.log('ContentList - props', props);

  const {
    relaxed,
    verticalAlign,
    bulleted,
    ordered,
    divided,
    size,
    bag,
  } = props;
  
  return (
    <>
      {/* <style dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize([
          '#layout-wrapper a.ui.button.postUpSignUpButton {',
          '  color: '+ textColor +';',
          '  box-shadow: inset 0 0 0 2px '+ textColor +' !important;',
          '}',
          '#layout-wrapper a.ui.button.postUpSignUpButton:hover {',
          '  color: '+ props.header_background_color +' !important;',
          '  background: '+ textColor +' !important;',
          '}'
          ].join('\n'))
        }}>
      </style> */}
      <div className={'site-content-list'}>
        <List
          relaxed={relaxed && relaxed === 'very' ? 'very' : relaxed === 'false' ? false : true}
          verticalAlign={verticalAlign ? verticalAlign : null}
          bulleted={bulleted ? true : false}
          ordered={ordered ? true : false}
          divided={divided ? true : false}          
          size={size ? size : 'large'}
        >
          {bag.contentItems && bag.contentItems.length !== 0 && bag.contentItems.map((contentItem, i) => {
            //console.debug('contentItem', contentItem);
            const { image, icon, header, description, commonContentLink, } = contentItem;
            const { 
              //linkContentText, dOMID, 
              externalLink, internalLink, mediaPDF 
            } = commonContentLink;
            return (
              <List.Item key={i} aria-label={(header ? header : description ? description : '')+' List Item'}
                as={internalLink.url !== null ? Link : externalLink.url !== null ? 'a' : mediaPDF?.gatsbyLocalFile?.publicURL !== null ? 'a' : null}
                to={internalLink.url !== null ? internalLink.url : null}
                href={externalLink?.url ? externalLink.url : mediaPDF?.gatsbyLocalFile?.publicURL ? mediaPDF.gatsbyLocalFile.publicURL : null}
                target={externalLink?.url || mediaPDF?.gatsbyLocalFile?.publicURL ? '_blank' : null}
                rel={externalLink?.url ? 'noreferrer' : null}
              >
                {icon && icon.iconName ?
                  <List.Icon name={icon.iconName} size='large' verticalAlign='middle' />
                :
                  null
                }
                {image && image.urls && image.urls.length !== 0 ?
                  <Image avatar src={image.urls[0]} />
                :
                  null
                }
                {header || description ?
                  <List.Content>
                    {header ?
                      <List.Header>{header}</List.Header>
                    :
                      null
                    }
                    {description ?
                      <List.Description>{description}</List.Description>
                    :
                      null
                    }
                  </List.Content>
                :
                  null
                }
              </List.Item>
            )
          })}
        </List>
      </div>
    </>
  )
}
